import { HStack, Stack } from '@chakra-ui/react';
import React from 'react';

import { Badge, Typography } from 'shared';
import { dateUtils } from 'shared_DEPRECATED/utils';

import { WidgetCardWrapper } from 'features/chat/components/ChatMessages/ChatMessage/Widgets/CardWrapper';
import { Widget } from 'features/chat/config/types/Message';

import {
  WidgetMeta,
  getJournalNotePreview,
  getJournalNoteTimestamp,
  getStatusBadgeTokens,
  getWidgetMeta,
  getWidgetTitle,
  resolveStatusText,
} from './widgetMeta';

type JournalWidgetProps = {
  widget: Widget;
  meta?: WidgetMeta;
};

export const JournalWidget = ({ widget, meta }: JournalWidgetProps) => {
  const computedMeta = meta ?? getWidgetMeta(widget);
  const title =
    getWidgetTitle(widget, computedMeta) ?? computedMeta.entityLabel;
  const timestamp = getJournalNoteTimestamp(widget);
  const preview = getJournalNotePreview(widget);
  const statusTokens = getStatusBadgeTokens(computedMeta.statusVariant);
  const statusText = resolveStatusText(widget, computedMeta);

  if (!title && !preview && !timestamp) {
    return null;
  }

  return (
    <WidgetCardWrapper>
      <Stack gap="12px" alignItems="flex-start">
        <HStack justifyContent="space-between" width="100%">
          <Badge colorPalette="lightGray">{computedMeta.entityLabel}</Badge>
          <Typography
            fontSize="14px"
            fontWeight="400"
            color="gray"
            lineHeight="normal"
          >
            {dateUtils(timestamp).format('MMM d, h:mm a')}
          </Typography>
        </HStack>

        {preview && (
          <Typography
            fontSize="14px"
            fontWeight="400"
            color="gray"
            lineHeight="normal"
          >
            {truncate(normalizeWhitespace(preview))}
          </Typography>
        )}
        <Badge
          bg={statusTokens.bg}
          color={statusTokens.color}
          borderRadius="12px"
        >
          {statusText}
        </Badge>
      </Stack>
    </WidgetCardWrapper>
  );
};

const truncate = (value: string, limit = 160) => {
  if (value.length <= limit) {
    return value;
  }

  return `${value.slice(0, limit).trimEnd()}...`;
};

const normalizeWhitespace = (value: string) =>
  value.replace(/\s+/g, ' ').trim();
